import { useRef, useState, useEffect } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  Button
} from "reactstrap";
import { postDataAPI } from "../../helpers/phpbackend_helper";

const TrainingVideoModal = ({ isOpen, toggle, card }) => {
  const videoRef = useRef(null);
  const [videoSrc, setVideoSrc] = useState(null);
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    fetchSignedUrlAndPlay();
  }, []);
  const fetchSignedUrlAndPlay = async () => {
    if (videoSrc || loading) return;

    setLoading(true);

    postDataAPI({
      serviceName: "server_data",
      op: "get-s3-video-url",
      video_id: card.video_id,
    })
      .then((res) => {
        if (res.status === "ok") {
          setVideoSrc(res.data.video_url);
          setTimeout(() => {
            videoRef.current?.play();
          }, 0);
        }
      })
      .finally(() => setLoading(false));
  };

  // const downloadVideo = async () => {
  //   const response = await fetch(videoSrc);

  //   if (!response.ok) {
  //     throw new Error("Download failed");
  //   }

  //   const blob = await response.blob();
  //   const url = window.URL.createObjectURL(blob);

  //   const a = document.createElement("a");
  //   a.href = url;
  //   a.download = card?.flash_card_name+"_training-video.mp4";
  //   document.body.appendChild(a);
  //   a.click();

  //   a.remove();
  //   window.URL.revokeObjectURL(url);
  // };

  // const downloadVideo = () => {
  //   const url = videoSrc; // your S3 signed URL

  //   const link = document.createElement("a");
  //   link.href = url;
  //   link.download = card?.flash_card_name+"_training-video.mp4";
  //   document.body.appendChild(link);
  //   link.click();
  //   document.body.removeChild(link);
  // };

 const downloadVideo = async () => {
    try {
      const response = await fetch(videoSrc);   // ✅ fetch the signed URL

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }

      const blob = await response.blob();       // ✅ now blob() works

      const blobUrl = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = blobUrl;
      link.download = card?.item_name.replace(/\s+/g, "_") + "_training-video.mp4";

      document.body.appendChild(link);
      link.click();

      link.remove();
      window.URL.revokeObjectURL(blobUrl);
    } catch (err) {
      console.error("Download failed", err);
    }
  };





  return (
    <Modal isOpen={isOpen} toggle={toggle} size="lg" centered>
      <ModalHeader toggle={toggle}>
        🎥 {card?.flash_card_name || card?.item_name} - Training Video
        <span className="badge bg-primary ms-2">
          {card?.course_name || ""}
        </span>
      </ModalHeader>

      <ModalBody>
        <div className="ratio ratio-16x9 mb-3">
          {/* <video
            src={card?.video_url} // HeyGen URL
            controls
            autoPlay
            controlsList="nodownload"
            className="rounded"
          /> */}
          <video
              ref={videoRef}
              controls
              preload="none"
              controlsList="nodownload"
              onPlay={fetchSignedUrlAndPlay}
            >
              {videoSrc && <source src={videoSrc} type="video/mp4" />}
            </video>

            {loading && (
              <div className="video-loading-overlay">
                Loading video…
              </div>
            )}
        </div>

        <div className="d-flex justify-content-end gap-2">
          {/* <Button outline>
            🔗 Share
          </Button> */}
          {/* <a
            href={videoSrc}
            download
            target="_blank"
            rel="noopener noreferrer"
          > */}
            <Button outline onClick={downloadVideo}>
            ⬇ Download
            </Button>
          {/* </a> */}
        </div>
      </ModalBody>
    </Modal>
  );
};

export default TrainingVideoModal;
